
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogi/[slug]",
      function () {
        return require("private-next-pages/blogi/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogi/[slug]"])
      });
    }
  